import { convertsToPlainText } from '#helpers/helpers.js';

export function checkIfDiffExist(incomingData, updatedData, type) {
    if (!incomingData || !updatedData) return false;
    console.log(incomingData, updatedData)
    let diffInFieldsExist, diffInGalleryExist, diffInDocsExist, diffInRoomsExist;
    // Check if the incomingData text fields is different from the updatedData text fields
    diffInFieldsExist = Object.keys(incomingData).some((key) => {
        if (
            typeof incomingData[key] !== 'object' &&
            key !== 'id' &&
            key !== 'rooms' &&
            key !== 'wrongDay' &&
            key != 'dayIndex' &&
            key != 'planIndex'
        ) {
            if (key === 'name' && incomingData?.type === 'suggestion')
                return convertsToPlainText(updatedData['suggestionId']) !== convertsToPlainText(incomingData['suggestionId']);
            return convertsToPlainText(updatedData[key] ?? '') !== convertsToPlainText(incomingData[key] ?? '');

        }
    });

    // Check if incomingData Gallery or Docs is different from updatedData Gallery or Docs
    diffInGalleryExist = incomingData?.gallery?.some((image) => {
        return !updatedData?.gallery?.some((img) => img.id === image.id);
    });

    if (type === 'plan') {
        diffInDocsExist = incomingData?.documents?.some((doc) => !updatedData?.documents?.some((id) => id === doc));
        // Check if incoming Rooms is different from updated Rooms
        diffInRoomsExist = incomingData?.rooms?.some((room) => {
            if (updatedData?.rooms?.some((r) => r.importId === room.importId)) {
                const updatedRoom = updatedData?.rooms?.find((r) => r.importId === room.importId);
                return checkIfDiffExist(room, updatedRoom, 'room');
            }
            return !updatedData?.rooms?.some((r) => r.importId === room.importId);
        });
    }
    return diffInFieldsExist || diffInGalleryExist || diffInDocsExist || diffInRoomsExist;
}

// Controlla se c'è una differenza nell'ordinamento dei plans in arrivo e quelli attuali
export function checkPlansOrder(incomingPlanner, updatedDays, updatedPlans) {
    const incomingPlans = incomingPlanner?.flatMap((day) => day.plans);

    let diff = false;
    incomingPlans.forEach((plan) => {
        const incomingDayIndex = incomingPlanner?.findIndex((day) =>
            day.plans.some((p) => p.importId === plan.importId)
        );
        const updatedDayIndex = updatedDays?.findIndex((day) => day.plans.some((p) => p.importId === plan.importId));

        const updatedPlan = updatedPlans?.some((p) => p.importId === plan.importId);
        if (!updatedPlan) {
            diff = true;
        }

        if (updatedPlan && incomingDayIndex !== updatedDayIndex) {
            diff = true;
        }
    });

    return diff;
}

export function checkHeadersAndDocs(incomingHeader, updatedHeader, incomingDocs, updatedDocuments) {
    let headerDiff, docsDiff;
    // Controlla se ci sono differenze tra i dati dell'header in arrivo e quelli attuali
    if (incomingHeader && updatedHeader) {
        const updatedHeaderItems = Object.keys(updatedHeader);
        headerDiff = updatedHeaderItems.some((key) => {
            if (key === 'cover' || key === 'jingle' || key === 'intro') {
                return incomingHeader[key]?.src && updatedHeader[key]?.src !== incomingHeader[key]?.src;
            }
            if (key === 'totalPrice' && incomingHeader[key] === undefined) return false;
            return updatedHeader[key] !== incomingHeader[key];
        });
    }
    // console.log('incomingHeader', incomingHeader);
    // console.log('updatedHeader', updatedHeader);

    // Controlla se ci sono differenze tra i dati dei documents in arrivo e quelli attuali
    if (incomingDocs && updatedDocuments)
        docsDiff = incomingDocs.some((doc) => !updatedDocuments.some((d) => d.id === doc.id));

    // console.log('incomingDocs', incomingDocs);
    // console.log('updatedDocuments', updatedDocuments);

    return headerDiff || docsDiff;
}
